<template>
  <div class="dashboard-container">
    <div class="logo-square"></div>
    <!-- <div style="position: absolute; top: 20000px">
      <div
        id="print-section"
        style="
          /* display: block; */
          top: 1500px;
          width: 800px;
          background-color: pink;
          height: 1121px;
          padding: 80px 60px;
          box-sizing: border-box;
          border: 1px solid grey;
        "
      >
        <div style="display: flex; flex-direction: column; align-items: center">
          <h3>PHIẾU THANH TOÁN</h3>
          <div>Mường Sang - Mộc Châu - Sơn La</div>
        </div>
        <hr />
        <div>
          <div>Công ty: ${company}</div>
          <div>Tên khách hàng: ${customer_name}</div>
          <div>Địa chỉ: ${address}</div>
          <div>Ngày nhận phòng: ${check_in_date}</div>
          <div>Ngày trả phòng: ${check_out_date}</div>
        </div>
        <hr />
        <table style="width: 100%">
          <tr>
            <th>STT</th>
            <th>Ngày</th>
            <th>Diễn giải</th>
          </tr>
          <tr>
            <td>${stt}</td>
            <td>${date}</td>
            <td>${note}</td>
          </tr>
        </table>
      </div>
    </div>
    <div style="position: fixed; bottom: 10px; right: 10px">
      <button @click="printSvg">Print PDF</button>
      <button @click="downloadSvg">Download PDF</button>
    </div> -->
  </div>
</template>
<script>
// import bus from '@/utils/bus'
// import html2pdf from 'html2pdf.js'
export default {
  methods: {
    // async printSvg() {
    //   bus.$emit('startLoader', { msg: '' })
    //   setTimeout(() => {
    //     const svgElement = document.getElementById('print-section')
    //     const options = {
    //       pagebreak: { mode: 'avoid-all' },
    //       margin: [0, 0],
    //       pagesplit: true,
    //       filename: 'test.pdf',
    //       image: { type: 'jpeg', quality: 1.0 },
    //       html2canvas: { scale: 5 },
    //       jsPDF: {
    //         unit: 'in',
    //         orientation: 'portrait',
    //         format: 'a4'
    //       }
    //     }
    //     html2pdf()
    //       .set({
    //         filename: 'test.pdf',
    //         jsPDF: {
    //           orientation: 'portrait'
    //         }
    //       })
    //       .from(svgElement)
    //       .set(options)
    //       .outputPdf()
    //       .get('pdf')
    //       .then(function (pdfObj) {
    //         pdfObj.autoPrint()
    //         window.open(pdfObj.output('bloburl'), 'F')
    //       })
    //       .catch(error => {
    //         console.log('kikikiki', error)
    //       })
    //   }, 400)
    //   setTimeout(() => {
    //     bus.$emit('endLoader')
    //   }, 600)
    // },
    // async downloadSvg() {
    //   bus.$emit('startLoader', { msg: '' })
    //   setTimeout(() => {
    //     const svgElement = document.getElementById('print-section')
    //     const options = {
    //       pagebreak: { mode: 'avoid-all' },
    //       margin: [0, 0],
    //       pagesplit: true,
    //       filename: '셀프진단결과.pdf',
    //       image: { type: 'jpeg', quality: 1.0 },
    //       html2canvas: { scale: 5 },
    //       jsPDF: {
    //         unit: 'in',
    //         orientation: 'portrait',
    //         format: 'a4'
    //       }
    //     }
    //     html2pdf().from(svgElement).set(options).save()
    //   }, 400)
    //   setTimeout(() => {
    //     bus.$emit('endLoader')
    //   }, 600)
    // }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  // background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
